const I = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA1MTMgMzQyIj4KPHJlY3QgZmlsbD0iI0ZGREE0NCIgd2lkdGg9IjUxMiIgaGVpZ2h0PSIzNDIiLz4KPHJlY3QgeD0iMzQyIiBmaWxsPSIjNkRBNTQ0IiB3aWR0aD0iMTcxIiBoZWlnaHQ9IjM0MiIvPgo8cmVjdCBmaWxsPSIjRDgwMDI3IiB3aWR0aD0iMTcxIiBoZWlnaHQ9IjM0MiIvPgo8L3N2Zz4K";
export {
  I as default
};
//# sourceMappingURL=GN-2861599f.mjs.map
